import {
  useLimitCampaignGroupTemplate,
  usePricingBilling,
  usePricingPlanActive,
} from '~/modules/pricing';
import { ICampaignLocked } from '../types';

export const useCGCampaignLimitByStatus = () => {
  const { activePlanKey } = usePricingPlanActive();
  const { isReachLimit, isOverLimit } = useLimitCampaignGroupTemplate({
    planKey: activePlanKey,
  });
  const { isLockedAppByBillFailed } = usePricingBilling();

  const lockedStatus = getLockedStatus();

  return {
    lockedStatus,
  };

  function getLockedStatus() {
    if (isLockedAppByBillFailed) return ICampaignLocked.BLOCKED_APP;
    if (isReachLimit) return ICampaignLocked.REACHED_LIMIT;
    if (isOverLimit) return ICampaignLocked.OVER_LIMIT;

    return null;
  }
};
